export enum Plans {
  BASIS = 'Plans5c2dc26da0e42',
  GULD = 'Plans5c0fe3bf1a498',
  PREMIUM = 'Plans5c2dc28fd7745',
  PREMIUM_PLUS = 'Plans5c2dc2a00377e',
  ALL_INCLUSIVE = 'e01f1a67-e3a2-44a2-95d6-22f803f0aaca',
}
